import React from 'react';
import cn from 'classnames';
import CheckoutSteps from '@app/common/CheckoutLayout/CheckoutSteps';
import ScopeAffix from '@base/lib/ScopeAffix';
import DefaultLoading from '@base/common/DefaultLoading';
import styles from './index.module.less';

type TCheckoutLayoutType = 'card' | 'divider';

type CheckoutLayoutProps = {
    step: number;
    loading?: boolean;
    sideElement?: React.ReactElement;
    type?: TCheckoutLayoutType;
}

type WithSideProps = {
    sideElement: React.ReactElement;
    type?: TCheckoutLayoutType;
}

export const WithSide: React.FC<WithSideProps> = props => {
    const { children, sideElement, type } = props;
    return (
        <div className={cn(styles['wrapper'], styles[`wrapper-${type}`], 'wrapper')} id="affix-scope">
            <div className={styles['grid-main']}>
                {children}
            </div>
            <ScopeAffix
                target={() => document.querySelector('#affix-scope')}
                className={styles['grid-side']}
                offset={type === 'card' ? 20 : 0}
            >
                {sideElement}
            </ScopeAffix>
        </div>
    );
};

const WithoutSide: React.FC = ({ children }) => (
    <div className="wrapper pb-footer">
        {children}
    </div>
);

const CheckoutLayout: React.FC<CheckoutLayoutProps> = props => {
    const {
        children,
        step,
        loading = false,
        sideElement,
        type = 'divider',
    } = props;

    return (
        <>
            <CheckoutSteps current={step}/>

            {loading ? <DefaultLoading type="page"/> : (
                sideElement
                    ? (
                        <WithSide
                            sideElement={sideElement}
                            type={type}
                        >
                            {children}
                        </WithSide>
                    )
                    : <WithoutSide>{children}</WithoutSide>
            )}
        </>
    );
};

export default CheckoutLayout;
